<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="bk">
<p class="bkau"><a class="page" id="piii"></a><a class="page" id="pii"></a>GARRETT STEWART</p>
<p class="bk">Closed Circuits</p>
<p class="bk1">SCREENING NARRATIVE SURVEILLANCE</p>
<p class="bkpub">UNIVERSITY OF CHICAGO PRESS</p>
<p class="bkpub1">CHICAGO AND LONDON</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-stewart-0003.vue?965cb1d6